import '~/sass/pages/tech-hybrid-3.scss';
import Vue from 'vue';
import Rx from 'rxjs/Rx';
import VueRx from 'vue-rx';
// import pcblock from '~/pages/includes/tech-hybrid/article1-pc.njk';
// import article1Mb from '~/pages/includes/tech-hybrid/article1-mb.njk';

Vue.use(VueRx, Rx);

export default () => {
  const article3Vm = new Vue({
    el: '#article3',
    props: [],
    components: {
      // AArticle3_pc,
      // AArticle3_mb,
    },
    data: () => ({
      clientWidth: document.body.clientWidth,
      showContent: false,
      options: {
        offset: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        threshold: 0.5,
      },
      once: false,
      playAnimate: 0,
    }),
    mounted() {
      this.showContent = true;
      this.$subscribeTo(
        Rx.Observable.fromEvent(window, 'resize')
          .debounceTime(100)
          .distinctUntilChanged(),
        this.onResize,
      );
    },
    beforeDestroy() {
      this.showContent = false;
    },
    computed: {
      isMobile() {
        const { clientWidth } = this;
        return clientWidth < 960;
      },
    },
    methods: {
      onResize() {
        this.clientWidth = document.body.clientWidth;
      },
      onAnimateLoaded() {
        this.playAnimate += 1;
      },
      close() {
        this.gaev('btn_article_3_close');
        this.$emit('close');
      },
    },
  });
  return article3Vm;
};
